export default __webpack_public_path__ + "static/media/code.8d8c11a8.mp3";